const doc = [({"en":({"js":({"layout":({"top_nav":({"you_were_signed_out":"You were signed out"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;